import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteSeasonEntity = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();
  const queryClient = useQueryClient();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (entityId: string) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities/${entityId}`, {
        method: "DELETE",
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "seasonEntity.delete.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["seasonEntities", sport, organizationId, seasonId] });
    },
  });
};
